/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Branch } from './Branch';
import {
    BranchFromJSON,
    BranchFromJSONTyped,
    BranchToJSON,
    BranchToJSONTyped,
} from './Branch';

/**
 * 
 * @export
 * @interface BranchWithNetSales
 */
export interface BranchWithNetSales {
    /**
     * 
     * @type {Branch}
     * @memberof BranchWithNetSales
     */
    branch: Branch;
    /**
     * 
     * @type {number}
     * @memberof BranchWithNetSales
     */
    net_sales: number;
}

/**
 * Check if a given object implements the BranchWithNetSales interface.
 */
export function instanceOfBranchWithNetSales(value: object): value is BranchWithNetSales {
    if (!('branch' in value) || value['branch'] === undefined) return false;
    if (!('net_sales' in value) || value['net_sales'] === undefined) return false;
    return true;
}

export function BranchWithNetSalesFromJSON(json: any): BranchWithNetSales {
    return BranchWithNetSalesFromJSONTyped(json, false);
}

export function BranchWithNetSalesFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchWithNetSales {
    if (json == null) {
        return json;
    }
    return {
        
        'branch': BranchFromJSON(json['branch']),
        'net_sales': json['net_sales'],
    };
}

export function BranchWithNetSalesToJSON(json: any): BranchWithNetSales {
    return BranchWithNetSalesToJSONTyped(json, false);
}

export function BranchWithNetSalesToJSONTyped(value?: BranchWithNetSales | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branch': BranchToJSON(value['branch']),
        'net_sales': value['net_sales'],
    };
}

